import { useMemo } from 'react';
import { sortOptionsByValue } from '../helpers/sortOptions';
import { useCluster } from 'src/features/cluster';
import { OneWayInOpportunitySimpleV2Dto } from 'src/api/v2';

const useMunicipality = (opportunities: OneWayInOpportunitySimpleV2Dto[]) => {
  const { cluster } = useCluster();
  const municipalityOptions = useMemo(() => {
    const oneWayInMunicipalities = cluster?.oneWayInMunicipalities || [];
    const municipalities = opportunities
      .map((opportunity) => opportunity?.municipality)
      .filter((x) => x !== undefined);

    const combinedMunicipalities = [...oneWayInMunicipalities, ...municipalities];

    const uniqueMunicipalities = [...new Set(combinedMunicipalities)];

    const municipality = uniqueMunicipalities.map((municipality) => ({
      text: municipality,
      value: municipality,
    }));

    return sortOptionsByValue(municipality);
  }, [cluster?.oneWayInMunicipalities, opportunities]);

  return { municipalityOptions };
};

export default useMunicipality;
